import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16.707 18.707 12-12a1 1 0 0 0-1.414-1.414L16 16.586l-5.293-5.293a1 1 0 0 0-1.414 0L5 15.586V6a1 1 0 0 0-2 0v20a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V13a1 1 0 1 0-2 0v12h-4v-6a1 1 0 1 0-2 0v6h-4v-2a1 1 0 1 0-2 0v2h-4v-6a1 1 0 1 0-2 0v6H5v-6.586l5-5 5.293 5.293a1 1 0 0 0 1.414 0"
    />
  </svg>
);
const SvgIconFinancialManagement = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFinancialManagement);
export default Memo;
